import { Button } from "@shopify/polaris";
import React, { Fragment, useCallback, useEffect, useReducer } from "react";

import { useAppContext } from "../../context";
import { checkRole, isPME_TEAM, reducerFn } from "../../helper";
import useToggle from "../../hooks/useToggle";
import BulkDeleteStore from "./components/BulkDeleteStore";
import BulkAddGroup from "./components/bulk-add-group";
import BulkConfigFulfillment from "./components/bulk-config-fulfillment";
import BulkConfigPrintwayFulfillment from "./components/bulk-config-printway-fulfillment";
import BulkUpdateChannelMember from "./components/bulk-update-channel-member";
import BulkUpdateMarketplaceManager from "./components/bulk-update-marketplace-manager";
import BulkUpdateStoreManager from "./components/bulk-update-store-manager";

export const BulkActionStore = () => {
    const { currentUser } = useAppContext();
    const { isSeller } = checkRole(currentUser);
    const { isRootUser } = currentUser || {};
    const isPME = isPME_TEAM(currentUser);

    // State
    const [open, toggleOpen] = useToggle(false);
    const [state, setState] = useReducer(reducerFn, {
        open: false,
        action: null,
    });

    const handleClickAct = useCallback(
        (act) => () => {
            setState({ action: act, open: true });
        },
        [],
    );

    const handleClose = useCallback(() => {
        setState({ action: null, open: false });
    }, []);

    useEffect(() => {
        console.log("window", window.location);
    }, []);

    const props = {
        open: state.open,
        onClose: handleClose,
    };

    const isAmazon = isAmazonRoute();
    const actionOb = {
        updateStoreManager: <BulkUpdateStoreManager {...props} />,
        addGroup: <BulkAddGroup {...props} />,
        updateMarketplaceManager: <BulkUpdateMarketplaceManager {...props} />,
        configFulfillment: <BulkConfigFulfillment {...props} />,
        configPrintwayFulfillment: <BulkConfigPrintwayFulfillment {...props} />,
        ...(isAmazon
            ? {
                  updateChannelMember: <BulkUpdateChannelMember {...props} />,
              }
            : {}),
    };

    const actionMarkup = actionOb[state.action] || null;
    const showConfig = isPME ? !!isRootUser : true;

    return (
        <Fragment>
            <Button
                children="Update Store Manager"
                onClick={handleClickAct("updateStoreManager")}
            />

            {isSeller ? (
                <Button
                    children="Update Marketplace Manager"
                    onClick={handleClickAct("updateMarketplaceManager")}
                />
            ) : null}

            <Button children="Add Group" onClick={handleClickAct("addGroup")} />
            {showConfig ? (
                <Button
                    children="Config Printify Fulfillment"
                    onClick={handleClickAct("configFulfillment")}
                />
            ) : null}
            {showConfig ? (
                <Button
                    children="Config Printway Fulfillment"
                    onClick={handleClickAct("configPrintwayFulfillment")}
                />
            ) : null}

            {isAmazon ? (
                <Button
                    children="Update Channel Members"
                    onClick={handleClickAct("updateChannelMember")}
                />
            ) : null}

            <Button children="Delete" destructive onClick={toggleOpen} />

            <BulkDeleteStore onClose={toggleOpen} open={open} />

            {actionMarkup}
        </Fragment>
    );
};

function isAmazonRoute() {
    const { pathname } = window.location || {};

    return !!(pathname || "").match(/amazon/);
}
